import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@porchpass/ui";
import { useState } from "react";

const TrashIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 14.625 16.125"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
  >
    <path
      d="M7.3623 3.10114e-07C7.73158 -1.02735e-05 8.04506 0.000161173 8.30566 0.0234378C8.58246 0.048195 8.8411 0.101387 9.0918 0.231446C9.19087 0.282846 9.28554 0.342454 9.375 0.40918C9.60138 0.57803 9.76226 0.787118 9.90527 1.02539C10.0399 1.24977 10.1768 1.53189 10.3379 1.86426L10.707 2.625H14.0625C14.3732 2.625 14.625 2.87684 14.625 3.1875C14.625 3.49816 14.3732 3.75 14.0625 3.75H13.4658L13.0322 10.7705C12.9744 11.7062 12.9291 12.4488 12.835 13.042C12.7384 13.6504 12.5834 14.1574 12.2744 14.6006C11.9918 15.0057 11.6279 15.3474 11.2061 15.6045C10.7448 15.8855 10.2293 16.0086 9.61621 16.0674C9.01828 16.1247 8.27363 16.125 7.33594 16.125H7.27832C6.33939 16.125 5.59376 16.1248 4.99512 16.0674C4.38134 16.0085 3.86593 15.885 3.4043 15.6035C2.98199 15.3459 2.61754 15.0037 2.33496 14.5977C2.02609 14.1538 1.87215 13.6462 1.77637 13.0371C1.68297 12.443 1.63763 11.699 1.58105 10.7617L1.1582 3.75H0.5625C0.25184 3.75 0 3.49816 0 3.1875C7.71591e-07 2.87684 0.25184 2.625 0.5625 2.625H3.99023L4.30469 1.93555C4.46185 1.59075 4.5948 1.29808 4.72754 1.06543C4.86841 0.818532 5.02868 0.601562 5.25781 0.425782C5.34823 0.356425 5.44431 0.294708 5.54492 0.241211C5.79987 0.105651 6.06364 0.0501907 6.34668 0.0244144C6.61345 0.000128447 6.93549 -1.05975e-05 7.31445 3.10114e-07H7.3623ZM2.70215 10.665C2.76087 11.6378 2.80366 12.3278 2.8877 12.8623C2.97031 13.3877 3.0854 13.7073 3.25781 13.9551C3.45111 14.2328 3.70038 14.4673 3.98926 14.6436C4.24695 14.8007 4.57312 14.8965 5.10254 14.9473C5.64111 14.9989 6.33231 15 7.30664 15C8.27992 15 8.97081 14.9998 9.50879 14.9482C10.0373 14.8976 10.3626 14.8013 10.6201 14.6445C10.9088 14.4686 11.1582 14.2343 11.3516 13.957C11.5241 13.7096 11.6404 13.39 11.7236 12.8652C11.8083 12.3316 11.8511 11.6429 11.9111 10.6719L12.3389 3.75H2.28516L2.70215 10.665ZM8.4375 10.2412C8.74816 10.2412 9 10.4931 9 10.8037C8.99974 11.1141 8.748 11.3662 8.4375 11.3662H6.1875C5.877 11.3662 5.62526 11.1141 5.625 10.8037C5.625 10.4931 5.87684 10.2412 6.1875 10.2412H8.4375ZM9.5625 7.30078C9.87304 7.30078 10.1248 7.55279 10.125 7.86328C10.125 8.17394 9.87316 8.42578 9.5625 8.42578H5.0625C4.75184 8.42578 4.5 8.17394 4.5 7.86328C4.5002 7.55279 4.75196 7.30078 5.0625 7.30078H9.5625ZM7.33789 1.125C6.92863 1.125 6.65884 1.12548 6.44922 1.14453C6.25027 1.16264 6.14846 1.19441 6.07324 1.23438C6.0275 1.2587 5.98349 1.28683 5.94238 1.31836C5.8748 1.37022 5.80411 1.44949 5.70508 1.62305C5.60075 1.80591 5.4882 2.05124 5.31836 2.42383L5.22656 2.625H9.45605L9.33594 2.37695C9.16163 2.01738 9.04618 1.78071 8.94043 1.60449C8.84006 1.43728 8.76909 1.36048 8.70215 1.31055C8.66158 1.28032 8.61814 1.25376 8.57324 1.23047C8.49914 1.19207 8.40004 1.16091 8.20605 1.14355C8.00133 1.12524 7.73764 1.125 7.33789 1.125Z"
      fill="currentColor"
    />
  </svg>
);

interface DeleteApplicationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  borrowerName?: string;
  onConfirm: () => Promise<void>;
}

export default function DeleteApplicationDialog({
  open,
  onOpenChange,
  borrowerName,
  onConfirm,
}: DeleteApplicationDialogProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
      onOpenChange(false);
    } catch {
      // Parent throws to keep dialog open (e.g. retryable 5xx).
      // Toast is fired by the parent; we just stay open.
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[440px] rounded-[20px] p-0 gap-0">
        <DialogHeader className="border-b border-[#e4e7ec] px-6 py-4">
          <DialogTitle className="text-base font-semibold text-[#111827]">
            Delete draft application
          </DialogTitle>
        </DialogHeader>
        <div className="px-6 py-6">
          <p className="text-base font-medium text-[#111827]">
            {borrowerName ? (
              <>
                Are you sure you want to delete the draft application for{" "}
                <span className="font-semibold">{borrowerName}</span>? This
                action cannot be undone.
              </>
            ) : (
              <>
                Are you sure you want to delete this draft application? This
                action cannot be undone.
              </>
            )}
          </p>
        </div>
        <DialogFooter className="gap-4 justify-end px-6 pt-0 pb-6">
          <DialogClose asChild>
            <Button variant="ghost" size="s" disabled={isLoading}>
              Cancel
            </Button>
          </DialogClose>
          <Button
            variant="destructive-secondary"
            size="s"
            onClick={() => void handleConfirm()}
            innerClassName="gap-2"
            loading={isLoading}
            disabled={isLoading}
          >
            Yes, delete draft
            <TrashIcon />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
